var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorFilledIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FFF4F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 30,
    fill: "#FEEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 13.75C25.5039 13.75 13.75 25.5039 13.75 40C13.75 54.4961 25.5039 66.25 40 66.25C54.4961 66.25 66.25 54.4961 66.25 40C66.25 25.5039 54.4961 13.75 40 13.75ZM49.6914 49.9727L45.8242 49.9551L40 43.0117L34.1816 49.9492L30.3086 49.9668C30.0508 49.9668 29.8398 49.7617 29.8398 49.498C29.8398 49.3867 29.8809 49.2812 29.9512 49.1934L37.5742 40.1113L29.9512 31.0352C29.8804 30.9493 29.8411 30.8418 29.8398 30.7305C29.8398 30.4727 30.0508 30.2617 30.3086 30.2617L34.1816 30.2793L40 37.2227L45.8184 30.2852L49.6855 30.2676C49.9434 30.2676 50.1543 30.4727 50.1543 30.7363C50.1543 30.8477 50.1133 30.9531 50.043 31.041L42.4316 40.1172L50.0488 49.1992C50.1191 49.2871 50.1602 49.3926 50.1602 49.5039C50.1602 49.7617 49.9492 49.9727 49.6914 49.9727Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFilledIcon);
export default __webpack_public_path__ + "static/media/error-filled-icon.4a8eae19b04ff6886e157ed9ab4c3ab4.svg";
export { ForwardRef as ReactComponent };